import CreateDuplicateProposalModal from './CreateDuplicateProposalModal';
export default CreateDuplicateProposalModal;
